import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-sm capitalize select-none whitespace-nowrap" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h-[2px] w-full bg-blue-500 absolute bottom-0" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'Item',
  props: {
  active: Boolean
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["group px-4 h-[40px] cursor-pointer relative flex items-center justify-center", {
      'text-gray-300': !__props.active,
      'text-blue-500': __props.active
    }])
  }, [
    _createElementVNode("p", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["group-hover:block absolute inset-0 pointer-events-none", {
        hidden: !__props.active
      }])
    }, _hoisted_3, 2)
  ], 2))
}
}

})